"use strict";

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var theme_1 = require("../../styles/theme");

var Caption = styled_1["default"].small(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Apercu Pro Italic', sans-serif;\n  color: ", ";\n  font-size: ", ";\n  line-height: 1.5;\n  letter-spacing: 0.512px;\n"], ["\n  font-family: 'Apercu Pro Italic', sans-serif;\n  color: ", ";\n  font-size: ", ";\n  line-height: 1.5;\n  letter-spacing: 0.512px;\n"])), function (props) {
  return props.dark ? theme_1.theme.secondaryDarkColor : theme_1.theme.secondaryColor;
}, theme_1.theme.fontSizes.small);
exports["default"] = Caption;
var templateObject_1;